import { makeStyles } from "@material-ui/core/styles";

/**
 * スタイルHook.
 *
 * @type {object}
 */
const useStyles = makeStyles(() => ({
  progressView: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
}));

export default useStyles;
